import { render } from "./ForgotPasswordSendEmail.vue?vue&type=template&id=5c4f4187"
import script from "./ForgotPasswordSendEmail.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordSendEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__